<template>
  <div>
    <Breadcrumb msg1="视光诊疗" msg2="验光记录" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="query.refraction_type" placeholder="验光类型" clearable>
            <el-option label="电脑验光" value="电脑验光"></el-option>
            <el-option label="综合验光" value="综合验光"></el-option>
            <el-option label="主觉验光" value="主觉验光"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-date-picker v-model="query.refraction_date" type="date" value-format="yyyy-MM-dd" placeholder="验光日期"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="验光日期" prop="refractionDate" width="110"></el-table-column>
        <el-table-column label="类型" prop="refractionType" width="100"></el-table-column>
        <el-table-column label="OD(球/柱/轴)" width="140">
          <template slot-scope="scope">{{ scope.row.subOdSphere }} / {{ scope.row.subOdCylinder }} / {{ scope.row.subOdAxis }}</template>
        </el-table-column>
        <el-table-column label="OS(球/柱/轴)" width="140">
          <template slot-scope="scope">{{ scope.row.subOsSphere }} / {{ scope.row.subOsCylinder }} / {{ scope.row.subOsAxis }}</template>
        </el-table-column>
        <el-table-column label="PD" prop="pd" width="70"></el-table-column>
        <el-table-column label="结论" prop="conclusion" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="800px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" v-if="show">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
                <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="验光日期"><el-date-picker v-model="form.refraction_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="验光类型">
              <el-select v-model="form.refraction_type" style="width: 100%">
                <el-option label="电脑验光" value="电脑验光"></el-option>
                <el-option label="综合验光" value="综合验光"></el-option>
                <el-option label="主觉验光" value="主觉验光"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验光师">
              <el-select v-model="form.optometrist_id" style="width: 100%">
                <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">电脑验光（OD 右眼 / OS 左眼）</el-divider>
        <el-row>
          <el-col :span="8"><el-form-item label="OD 球镜"><el-input v-model="form.auto_od_s"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 柱镜"><el-input v-model="form.auto_od_c"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 轴位"><el-input v-model="form.auto_od_a"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 球镜"><el-input v-model="form.auto_os_s"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 柱镜"><el-input v-model="form.auto_os_c"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 轴位"><el-input v-model="form.auto_os_a"></el-input></el-form-item></el-col>
        </el-row>
        <el-divider content-position="left">综合验光（主觉）</el-divider>
        <el-row>
          <el-col :span="8"><el-form-item label="OD 球镜"><el-input v-model="form.sub_od_s"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 柱镜"><el-input v-model="form.sub_od_c"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 轴位"><el-input v-model="form.sub_od_a"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 球镜"><el-input v-model="form.sub_os_s"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 柱镜"><el-input v-model="form.sub_os_c"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 轴位"><el-input v-model="form.sub_os_a"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 下加光"><el-input v-model="form.sub_od_add"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 下加光"><el-input v-model="form.sub_os_add"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="近用PD"><el-input v-model="form.pd_near"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="瞳距PD" required><el-input v-model="form.pd"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OD 视力"><el-input v-model="form.visual_acuity_od"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="OS 视力"><el-input v-model="form.visual_acuity_os"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="下次复查"><el-date-picker v-model="form.next_review_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="结论"><el-input v-model="form.conclusion" type="textarea"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, customer_id: null, refraction_type: '', refraction_date: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      customerOptions: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    getData () {
      this.$axios.get('/optometries', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    emptyForm () {
      return { customer_id: null, refraction_date: '', refraction_type: '综合验光', optometrist_id: null, pd: '', pd_near: '', visual_acuity_od: '', visual_acuity_os: '', auto_od_s: '', auto_od_c: '', auto_od_a: '', auto_os_s: '', auto_os_c: '', auto_os_a: '', sub_od_s: '', sub_od_c: '', sub_od_a: '', sub_od_add: '', sub_os_s: '', sub_os_c: '', sub_os_a: '', sub_os_add: '', conclusion: '', next_review_date: '', remark: '' }
    },
    add () {
      this.dialogTitle = '新增验光记录'
      this.form = this.emptyForm()
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑验光记录'
      // 响应为 camelCase 实体，回填时映射回表单 snake_case 字段（请求体保持 snake_case 不变）
      this.form = Object.assign(this.emptyForm(), {
        id: row.id,
        customer_id: row.customerId,
        refraction_date: row.refractionDate,
        refraction_type: row.refractionType,
        optometrist_id: row.optometristId,
        pd: row.pd,
        pd_near: row.pdNear,
        visual_acuity_od: row.visualAcuityOd,
        visual_acuity_os: row.visualAcuityOs,
        auto_od_s: row.autoOdSphere,
        auto_od_c: row.autoOdCylinder,
        auto_od_a: row.autoOdAxis,
        auto_os_s: row.autoOsSphere,
        auto_os_c: row.autoOsCylinder,
        auto_os_a: row.autoOsAxis,
        sub_od_s: row.subOdSphere,
        sub_od_c: row.subOdCylinder,
        sub_od_a: row.subOdAxis,
        sub_od_add: row.addPower,
        sub_os_s: row.subOsSphere,
        sub_os_c: row.subOsCylinder,
        sub_os_a: row.subOsAxis,
        conclusion: row.conclusion,
        next_review_date: row.nextReviewDate,
        remark: row.remark
      })
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/optometries/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/optometries', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/optometries/${id}`, () => this.getData())
    }
  }
}
</script>
